<template>
    <div class="shipData">
        <navs></navs>
        <div class="shipBox">
            <p class="starTitle">航运大数据</p>
            <p class="beiIntro">航运大数据是基于全球船舶自动识别系统（AIS）、官方数据以及平台多年沉淀的用户数据，运用物联网、云计算及人工智能等技术，结合数据挖掘、深度学习、智能预测等算法，实现对全球80万+船舶数据多维度分析，对提升船货运输效率，船舶安全管理、业务可视化跟踪、航行决策分析、业务精准推广等方面具有重要的商业价值</p>
            <div class="starsImg"></div>
        </div>

          <!--数据采集-->
        <div class="shipIntroBoxs">
           <div class="titles">动态数据</div>
           <p class="collectSub">
               能够实时监控船舶当前所在的位置、经纬度、载货状况、当前吃水、航速、状态（航行、锚泊或者靠泊）、停靠时长、航行时间、航行方向、出发港及出发时间、目的港及预抵时间、航行轨迹、历史状态等
            </p>
            <div class="collectImg"></div>
        </div>
        <div class="shipIntroBoxs">
           <div class="titles">静态数据</div>
           <p class="collectSub">
               可查询船舶规范信息，包含船舶类型、船长、船宽、总吨、净吨、载重吨、建造时间、满载吃水、船籍港、舱口数据、船舶图片、船舶经营人、船舶所有人及船东信息等
            </p>
            <div class="collectImg1"></div>
        </div>
         <div class="shipIntroBoxs">
           <div class="titles">船队管理</div>
           <p class="collectSub">
               将船舶添加至船队，可随时监控船队船舶的位置，接收船舶动态提醒（吃水变动、状态变动等），帮助客户进行可视化、数字化管理
          </p>
            <div class="collectImg2"></div>
        </div>
         <div class="shipIntroBoxs">
           <div class="titles">订阅提醒</div>
           <p class="collectSub">
              设置关注的港口，当有船舶前往该港口时，会收到消息通知
           </p>
            <div class="collectImg3"></div>
        </div>
         <div class="shipIntroBoxs">
           <div class="titles">港口监测</div>
           <p class="collectSub">
              分析和监测全国港口货运吞吐量，运力分布情况、货物流向、船舶流向、靠泊计划、封航信息、航行通告等，为海运用户提供数据报告
           </p>
            <div class="collectImg4"></div>
        </div>
          <div class="shipIntroBoxs" style="border:none">
           <div class="titles">风险预警</div>
           <p class="collectSub">
              为船舶航行提供海上风浪预警、潮汐提醒及碰撞预警等。碰撞预警通过分析附近航行船舶的航速、航向，风向、风速等预测船舶行驶路线，对可能存在碰撞风险及时预警
              </p>
            <div class="collectImg5"></div>
        </div>
         <!--行业解决方案-->
        <div class="hangBox">
            <p class="beiName">行业解决方案</p>
            <van-swipe :autoplay="false" :loop="false" :width="180" :class="[{'beiSwipeBox':index1},{'beiSwipeBox1':index2},{'beiSwipeBox2':index3},{'beiSwipeBox3':index4}]" @change="onChangeBanner">
                    <van-swipe-item >
                        <div class="beiInner">
                            <img src="../assets/hang-ico1.png" class="beiImg">
                            <div class="beiLine"></div>
                            <p class="beiTitle">货物运输解决方案</p>
                            <p class="beiIntro">通过船舶多维数据对货物运输资源进行智能匹配，降低船舶等待时间及空载率，提高船舶运输效率及流转率</p>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                         <div class="beiInner">
                            <img src="../assets/hang-ico2.png" class="beiImg1">
                            <div class="beiLine"></div>
                            <p class="beiTitle">业务管理解决方案</p>
                            <p class="beiIntro">为行业相关群体提供移动端产品船查查及SaaS管理系统，方便对船舶进行可视化跟踪与管理</p>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="beiInner">
                            <img src="../assets/hang-ico3.png" class="beiImg2">
                            <div class="beiLine"></div>
                            <p class="beiTitle">政府机构解决方案</p>
                            <p class="beiIntro">方便海事、交管、税务等部门对船舶进行可视化管控，监控船舶超载、危险驾驶、非法装货、虚假业务、交通调度等</p>
                        </div>
                    </van-swipe-item>
                    <van-swipe-item>
                        <div class="beiInner">
                            <img src="../assets/hang-ico4.png" class="beiImg3">
                             <div class="beiLine"></div>
                            <p class="beiTitle">金融保险解决方案</p>
                            <p class="beiIntro">提供标准化数据接口，监测船舶动态，追踪历史轨迹，帮助进行风险评估</p>
                        </div>
                    </van-swipe-item>

            </van-swipe>
        </div>

        <foot></foot>
        <rightC></rightC>
    </div>
</template>
<script>
import navs from '@/components/nav/head';
import foot from '@/components/nav/footer';
import rightC from '@/components/nav/rightFloat'
export default {
    name:'shipData',
    data(){
        return{
          current: 0,
          index1:true,
          index2:false,
          index3:false,
          index4:false,
          index5:false,
        }
    },
    components:{
     navs,foot,rightC
    },
    created(){

    },
     methods:{
        onChangeBanner(index){
           if(index == 0){
                this.index1=true
               this.index2=false;
               this.index3=false;
               this.index4=false;
               this.index5=false;
           }else if(index ==1){
               this.index1=false;
               this.index2=true;
               this.index3=false;
               this.index4=false;
               this.index5=false;
           }else if(index ==2){
               this.index1=false;
               this.index2=false;
               this.index3=true;
               this.index4=false;
               this.index5=false;
           }else if(index == 3){
                this.index1=false;
               this.index2=false;
               this.index3=false;
               this.index4=true;
               this.index5=false;
           }else{
                this.index1=false;
               this.index2=false;
               this.index3=false;
               this.index4=false;
               this.index5=true;
           }
        }

    }
}
</script>
<style lang='less' rel='stylesheet/less' >
   @rem:16rem;
   @col-f:#fff;

   .shipBox{
       width: 100%;
       height: 448/@rem;
       background: #15181E;
        text-align: center;
       .starTitle{
           padding-top: 30/@rem;
            font-size: 18/@rem;
             text-align: center;
             color:  @col-f;
            font-weight: 300;
       }
       .beiIntro{
           font-size: 10/@rem;
            color:  @col-f;
            padding-left: 19/@rem;
            padding-right:19/@rem;
            font-weight: 300;
         text-align: left;
            line-height: 20/@rem
       }
       .starsImg{
           width: 100%;
           height: 248/@rem;
            background: url('../assets/hang.png');
            background-repeat: no-repeat;
            background-position: center bottom;
            background-size: 310/@rem 240/@rem;
       }
   }


  .shipIntroBoxs{
       padding: 22/@rem 0;
       margin: 0 16/@rem;
       border-bottom: 1px solid #E3E9EF;
    .titles{
       font-size: 16/@rem;
       text-align: center;
       color:  #333;
       font-weight: bold;
  }
      .collectSub{
          font-size: 10/@rem;
          color: #666;
          text-align: center;
        //   text-align:justify;
        //   text-align-last: center;

      }

      .collectImg{

            width: 100%;
            height: 244/@rem;
            background: url('../assets/hang-pic1.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 148/@rem 204/@rem;
      }
       .collectImg1{

            width: 100%;
            height: 244/@rem;
            background: url('../assets/hang-pic2.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 148/@rem 204/@rem;
      }
       .collectImg2{

            width: 100%;
            height: 244/@rem;
            background: url('../assets/hang-pic3.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 148/@rem 204/@rem;
      }
       .collectImg3{

            width: 100%;
            height: 244/@rem;
            background: url('../assets/hang-pic4.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 148/@rem 164/@rem;
      }
       .collectImg4{

            width: 100%;
            height: 244/@rem;
            background: url('../assets/hang-pic5.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 148/@rem 204/@rem;
      }
       .collectImg5{

            width: 100%;
            height: 244/@rem;
            background: url('../assets/hang-pic6.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 148/@rem 164/@rem;
      }

  }
  .swipeBox{
      height: 13.2rem;
  }
 .hangBox{
       width: 100%;
       height: 310/@rem;
       background-image: url('../assets/hang-bg.png');
       background-repeat: no-repeat;
       background-position: center center;
       background-size: ceil(100%) ceil(100%);


   .beiName{
       font-weight: bold;
       font-size: 14/@rem;
       text-align: center;
       color: #333;
       padding-top: 26/@rem;
       padding-bottom: 14/@rem
   }
   .beiInner{
       width: 131/@rem;
       height: 170/@rem;
       background: #fff;
       margin-left: 20/@rem;
       text-align: center;

       .beiImg{
           width: 28/@rem;
           padding-top: 12/@rem;
       }
        .beiImg1{
           width: 18/@rem;
           padding-top: 12/@rem;
       }
       .beiImg2{
           width: 26/@rem;
           padding-top: 12/@rem;
       }
         .beiImg3{
           width: 26/@rem;
           padding-top: 12/@rem;
       }
       .beiLine{
           height: 0.2rem;
           background-image: url('../assets/hang-line.png');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 1.4rem 0.2rem;
            margin-bottom: 0.4rem;
       }
       .beiTitle{
          font-size:10/@rem;
          font-weight: 800;
          color: #333;
          margin: 0
       }
       .beiIntro{
          font-size:9/@rem;
          color: #666;
          margin: 0 ;
          padding: 10/@rem 14/@rem;
         text-align: left;
          line-height: 16/@rem
       }
     }
   }
    .beiSwipeBox{
       height: 13.5rem;
       width: 100%;
       .van-swipe-item{
           width: 210/@rem;
       }
        .van-swipe__track{
              transform: translateX(-0px) !important;
        }
   }
    .beiSwipeBox1{
       height: 13.5rem;
       width: 100%;
       .van-swipe-item{
           width: 210/@rem;
       }
        .van-swipe__track{
              transform: translateX(-180px) !important;
        }
   }
    .beiSwipeBox2{
       height: 13.5rem;
       width: 100%;
       .van-swipe-item{
           width: 210/@rem;
       }
        .van-swipe__track{
              transform: translateX(-285px) !important;
        }
   }
     .beiSwipeBox3{
       height: 13.5rem;
       width: 100%;
       .van-swipe-item{
           width: 210/@rem;
       }
        .van-swipe__track{
              transform: translateX(-340px) !important;
        }
   }
</style>



// WEBPACK FOOTER //
// src/components/shipData.vue